/* tslint:disable:no-access-missing-member */
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import Highcharts from 'highcharts';
import * as api from '../../../../api';
import { ApiRequestDto } from '../../../../api';
import { FacilitiesService } from '../../../../core/facilities/facilities.service';
import { ChartOptionsFactory } from '../../../chart-options-factory';
import { AbstractAggregateChartsComponent } from "../../abstract-aggregate-charts.component";
import { AbstractCorporateDashboardChartsComponent } from "./abstract-corporate-dash-charts.component";

/**
 * Total Pharmacy Cost Summary Widget - shows pair of charts.
 */
@Component({
    selector: 'my-non-covered-charges-chart',
    template: `
        <div class="corp-dash">
            <div class="col-12">
                <div class="col-6 border-right">
                    <div #lastQuarterChart style="height: 250px;"></div>
                </div>
                <div class="col-6">
                    <div #thisQuarterChart  style="height: 250px;"></div>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['abstract-corporate-dash-chats.component.scss'],
    inputs: AbstractAggregateChartsComponent.INPUTS

})
export class NonCoveredChargesChartComponent extends AbstractCorporateDashboardChartsComponent implements AfterViewInit {

    ////// Donut Chart of Total Cost
    @ViewChild('thisQuarterChart', {static: false}) thisQuarterChartDivRef: ElementRef;
    private thisQuarterChart: Highcharts.Chart;

    ////// Bar Chart by Pay Type
    @ViewChild('lastQuarterChart', {static: false}) lastQuarterChartDivRef: ElementRef;
    private lastQuarterChart: Highcharts.Chart;

    /** Construct */
    constructor(private financialApi: api.FinancialService,
                facilitiesSvc: FacilitiesService,) {
        super(facilitiesSvc);
    }

    /**
     * Setup the charts.
     * @Override
     */
    buildAllCharts(): void {
        let thisQuarterChartOptions = ChartOptionsFactory.buildColumnType('This Quarter', '', null);
        thisQuarterChartOptions = ChartOptionsFactory.removeTitleTooltip(thisQuarterChartOptions);

        super.customizeChartOptions(thisQuarterChartOptions);

        this.thisQuarterChart = super.createChart(this.thisQuarterChartDivRef, thisQuarterChartOptions);

        let lastQuarterChartOptions = ChartOptionsFactory.buildColumnType('Last Quarter', '', null);
        lastQuarterChartOptions = ChartOptionsFactory.removeTitleTooltip(lastQuarterChartOptions);
        super.customizeChartOptions(lastQuarterChartOptions);

        this.lastQuarterChart = super.createChart(this.lastQuarterChartDivRef, lastQuarterChartOptions)

    }

    /**
     * Fetch all data and update display
     * @override
     */
    fetchAndPopulate(): void {
        const thisQuarter = super.calculateBillingDateRange('This Quarter');
        const lastQuarter = super.calculateBillingDateRange('Last Quarter');

        let requestParamsThisQtr: ApiRequestDto = {
            StartDate: thisQuarter.startJsDateUTC,
            EndDate: thisQuarter.endJsDateUTC,
            OrgList: this.facilitiesSvc.selectedAsOrgList
        };

        super.getDataForChart(
            this.financialApi.financialGetTotalNonCoveredCharges(requestParamsThisQtr),
            this.financialApi.financialGetTotalNonCoveredChargesByMonth(requestParamsThisQtr, this.facilitiesSvc.billCutOffDateForSelectedFacility), 
            this.thisQuarterChart, 
            this.thisQuarterChartDivRef);

        let requestParamsLastQtr: ApiRequestDto = {
            StartDate: lastQuarter.startJsDateUTC,
            EndDate: lastQuarter.endJsDateUTC,
            OrgList: this.facilitiesSvc.selectedAsOrgList
        };
        super.getDataForChart(
            this.financialApi.financialGetTotalNonCoveredCharges(requestParamsLastQtr),
            this.financialApi.financialGetTotalNonCoveredChargesByMonth(requestParamsLastQtr, this.facilitiesSvc.billCutOffDateForSelectedFacility), 
            this.lastQuarterChart, 
            this.lastQuarterChartDivRef);
    }
}